import React, { useEffect, useState } from 'react';
import { Container, Alert } from 'react-bootstrap';
import queryString from 'query-string';
import { useCookies } from 'react-cookie';
import publicIp from 'react-public-ip';
import { useHistory, useLocation } from 'react-router-dom';
import axiosInterceptor from '../../services/axiosInterceptor';
import loader from '../../assets/images/loading.gif';
import { language } from '../../language';
import '../../styles/home.css';

function CallBackPage() {
    const history = useHistory();
    const location = useLocation();

    const [loaderStatus, setLoaderStatus] = useState(true);

    const [authCookie, setAuthCookie, removeAuthCookie] = useCookies([
        'oauth_token',
        'access_token',
        'email_collected'
    ]);

    useEffect(() => {
        (async () => {
            // Check if state has collectData variable or not. If yes, Crawl twitter data
            if (location?.state?.collectData) {
                try {
                    collectData();
                } catch (error) {
                    console.error(error);
                }
            }
            // Check logic after Successful Twitter Login
            else {
                if (localStorage.getItem('twclid')) {
                    try {
                        // Check whether twclid is already used to twitter SSO or not
                        const check_twclid = await axiosInterceptor().post(
                            'twitter/auth/checkAndCreateTwclid',
                            { twclid: localStorage.getItem('twclid') }
                        );

                        // Ineligible if twclid is already used
                        if (check_twclid?.data?.check == 'Existing Twclid') {
                            inEligibleError();
                        }
                        // Check Main Call Back Logic
                        else {
                            callBackLogic();
                        }
                    } catch (err) {
                        console.log(err);
                    }
                }
                // Check Main Call Back Logic
                else {
                    callBackLogic();
                }
            }
        })();
    }, [authCookie?.oauth_token]);

    let callBackLogic = async () => {
        const { oauth_token, oauth_verifier } = queryString.parse(
            window.location.search
        );

        // If URL contains both oauth_token and oauth_verifier tokens after successful twitter login
        if (oauth_token && oauth_verifier) {
            try {
                //Oauth Step 3
                // Update Access Tokens and Secret tokens in DB
                const token_data = await axiosInterceptor().post(
                    'twitter/auth/access_token',
                    {
                        oauth_token: oauth_token,
                        oauth_verifier: oauth_verifier
                    }
                );

                // Successful Oauth Step 3
                if (token_data?.data?.success) {
                    // Get User Profile Information from Twitter API
                    const profile_data = await axiosInterceptor().post(
                        'twitter/auth/getProfileInfo',
                        { oauth_token: authCookie?.oauth_token }
                    );

                    // Check whether user has more than or equal to 20 tweets
                    if (profile_data?.data?.tweets >= 20) {
                        if (localStorage.getItem('return_token')) {
                            // Verify the return token of the user when user clicked on verification link in email
                            const token_check = await axiosInterceptor().post(
                                'twitter/checkReturnToken',
                                {
                                    username: profile_data?.data?.username,
                                    token: localStorage.getItem('return_token')
                                }
                            );

                            // If email return token is wrong, user is ineligible
                            if (token_check?.data?.check == 'Failed') {
                                await inEligibleError();
                            }
                            // If email return token is correct, call Sub Callback logic
                            else if (token_check?.data?.check == 'Success') {
                                // Call Sub Callback logic with return token parameter
                                subCallBackLogic(
                                    profile_data,
                                    token_check?.data?.check
                                );
                            }
                        } else {
                            // Call Sub Callback logic with no return token parameter
                            subCallBackLogic(profile_data, 'No Return');
                        }
                    }
                    // Failed to meet 20 tweets criteria
                    else {
                        inEligible(profile_data?.data?.username);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    let subCallBackLogic = async (profile_data, token_check) => {
        // Check user is legit or not
        console.log("---- subCallBackLogic language:"+language)
        const user_check = await axiosInterceptor().post(
            'twitter/checkAndCreateUser',
            {
                username: profile_data?.data?.username,
                ip: (await publicIp.v4()) || '',
                webLang:  language == "en" ? "en":"fr"
            }
        );

        // InEligible User Verification
        if (
            (user_check?.data?.check == 'Invalid User' ||
                user_check?.data?.check == 'IP Duplicate') &&
            token_check != 'Success'
        ) {
            inEligibleError();
        }
        // Eligible User
        else {
            // Set Access token and Email Collected cookies
            setAuthCookie('access_token', profile_data?.data?.accessToken, {
                maxAge: 86400,
                secure: true
            });

            if (user_check?.data?.email || token_check == 'Success') {
                setAuthCookie('email_collected', 'true', {
                    maxAge: 86400,
                    secure: true
                });
            } else {
                setAuthCookie('email_collected', 'false', {
                    maxAge: 86400,
                    secure: true
                });
            }

            // If User has deleted account, then user is ineligble from next login
            if (user_check?.data?.deletedAccount) {
                inEligible(profile_data?.data?.username);
            } else {
                // Created new user
                if (user_check?.data?.check == 'Created User') {
                    history.push('/consent');
                }
                // Existing User
                else if (user_check?.data?.check == 'Existing User') {
                    history.push('/survey');
                }
                // Users enters site from Return Token
                else if (token_check == 'Success') {
                    history.push('/survey');
                }
                // Unauthorized Users
                else {
                    history.push('/');
                }
            }
        }
    };

    // Crawl Twitter Data
    let collectData = async () => {
        // Get User Profile Information from Twitter API to get twitter username and bio
        const profile_data = await axiosInterceptor().post(
            'twitter/auth/getProfileInfo',
            { oauth_token: authCookie?.oauth_token }
        );

        // Crawl data after user accept consent
        await axiosInterceptor().post('twitter/updateConsent', {
            username: profile_data?.data?.username
        });

        // If user has less than 20 tweets, Ineligible
        if (profile_data?.data?.tweets < 20) {
            inEligible(profile_data?.data?.username);
        }
        // Successfully Crawl Data
        else {
            axiosInterceptor().post('twitter/getUserInfo', {
                username: profile_data?.data?.username,
                bio: profile_data?.data?.bio,
                portal: 'incas'
            });
            history.push('/conversion');
        }
    };

    let inEligible = async (username) => {
        await inEligibleError();
    };

    // Ineligible Users functionality
    let inEligibleError = async () => {
        setLoaderStatus(false);
        let i = 0;
        // Logout logic
        const interval = setInterval(async () => {
            await axiosInterceptor().post('twitter/auth/logout', {
                oauth_token: authCookie?.oauth_token
            });
            removeAuthCookie('oauth_token');
            removeAuthCookie('access_token');
            removeAuthCookie('email_collected');
            localStorage.removeItem('twclid');
            localStorage.removeItem('return_token');
            history.push('/');
            i += 1;
            if (i === 1) {
                clearInterval(interval);
            }
        }, 5 * 1000);
    };

    return (
        <Container>
            {loaderStatus && (
                <div className="blur-screen">
                    <img src={loader} alt="preview" className="loader-image" />
                </div>
            )}
            {!loaderStatus && (
                <Alert variant="danger" className="text-center">
                    You are ineligible for this Research Survey. Thanks for your
                    time.
                </Alert>
            )}
        </Container>
    );
}

export default CallBackPage;
